
import { Loader2, FileText, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DocumentPreviewProps {
  isLoadingPreview: boolean;
  documentUrl: string | null;
  title: string;
  onDownload: () => void;
}

export function DocumentPreview({ 
  isLoadingPreview, 
  documentUrl, 
  title, 
  onDownload 
}: DocumentPreviewProps) {
  return (
    <div className="rounded-md border overflow-hidden bg-background h-[600px]">
      {isLoadingPreview ? (
        <div className="flex items-center justify-center h-full">
          <div className="flex flex-col items-center gap-2">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p className="text-sm text-muted-foreground">Loading document preview...</p>
          </div>
        </div>
      ) : documentUrl ? (
        <iframe 
          src={documentUrl} 
          className="w-full h-full" 
          title={title}
        />
      ) : (
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <FileText className="h-12 w-12 mx-auto text-muted-foreground mb-2" />
            <p className="text-muted-foreground">Preview not available</p>
            <Button 
              variant="outline" 
              size="sm" 
              className="mt-4"
              onClick={onDownload}
            >
              <Download className="mr-2 h-4 w-4" />
              Download File
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
